export default __webpack_public_path__ + "static/media/slider4en.d88019de.jpg";